import { href, Link } from 'react-router'
// Imported (not a `public/` path) so Vite fingerprints it into
// `/assets/wordmark-dark-<hash>.svg` and it caches across page loads, rather
// than inlining the SVG markup into every SSR'd HTML document (VIT-17790).
import wordmarkDarkUrl from '../images/wordmark-dark.svg'

// Per VIT-16754 the "Log in" / "Sign up" links from the source design are
// intentionally omitted — there is no auth on the stub site yet.
//
// `actions` fills the right-hand side of the bar, which the wordmark otherwise
// leaves empty (VIT-17951). Optional, and the row is already justify-between, so
// pages that pass nothing render exactly as before.
export function SiteHeader({ actions }: { actions?: React.ReactNode }) {
  return (
    <header className="px-3 sm:px-4">
      <div className="mx-auto flex py-3 sm:py-6 max-w-7xl items-center justify-between">
        <div className="flex items-baseline">
          <Link
            aria-label="Vital Care Finder — home"
            className="flex flex-none items-baseline gap-2 no-underline"
            to={href('/')}
            viewTransition
          >
            <img
              src={wordmarkDarkUrl}
              alt="Vital Atlas"
              width={220}
              height={50}
              // Intrinsic width/height stay at the desktop size so the box is reserved
              // before the SVG loads; the classes scale it down on small screens only
              // (VIT-17951). `xs` is the 475px breakpoint declared in app.css.
              className="h-auto w-[168px] xs:w-[190px] sm:w-[220px] [view-transition-name:wordmark]"
            />
          </Link>
        </div>
        {actions}
      </div>
    </header>
  )
}
